import { createFeatureSelector, createSelector } from '@ngrx/store';
import { initialState } from './course.reducer'; 
import { coursedetailsState } from './course.modal';

export const courseState = createFeatureSelector<coursedetailsState>('course');

export const courseAllData = createSelector(
    courseState,
    (state: coursedetailsState) => state
)

export const courseId = createSelector(
    courseState,
    // (state: coursedetailsState) => ({courseId: state.course_id, courseType: state.course_type})
    (state: coursedetailsState) => state.course_id
)

export const courseDetails = createSelector(
    courseState,
    (state: coursedetailsState) => state.course_details
);

export const courseStructure = createSelector(
    courseState,
    (state: coursedetailsState) => state.course_structure
);

export const coursePrice = createSelector(
    courseState,
    (state: coursedetailsState) => state.course_price
);

export const courseAchievements = createSelector(
    courseState,
    (state: coursedetailsState) => state.course_achievements
);
